import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from '@/components/ui/carousel';
import Autoplay from 'embla-carousel-autoplay';
import { Star } from 'lucide-react';
import { useRef } from 'react';

const testimonials = [
  { name: 'Sarah Mitchell', role: 'Founder, Luxe Beauty Co.', text: 'Trademark Pact made the entire trademark registration process seamless. Their team handled everything from the initial search to the final registration. Highly recommended for any business owner looking to protect their brand.' },
  { name: 'David Chen', role: 'CEO, TechVault Solutions', text: 'After receiving an office action, I was worried our application would be denied. The team at Trademark Pact crafted a brilliant response that got our trademark approved. Their expertise is unmatched.' },
  { name: 'Rachel Anderson', role: 'Owner, Green Path Organics', text: 'I needed help with both trademark registration and company formation. Trademark Pact provided comprehensive guidance through both processes, saving me time and ensuring everything was done right.' },
  { name: 'Marcus Williams', role: 'Director, Atlas Consulting', text: 'The clearance search service saved us from a potential infringement disaster. They identified a conflicting mark we would have never found on our own, and helped us pivot our branding strategy.' },
  { name: 'Jennifer Lopez-Rivera', role: 'Founder, Artisan Home Studio', text: 'Outstanding service from start to finish. The monitoring service has already caught two potential infringements, and their team acted quickly to protect our brand each time.' },
  { name: 'Thomas Bergstrom', role: 'Managing Partner, Nordic Imports', text: 'We used Trademark Pact for Amazon Brand Registry enrollment. The process was straightforward and their team handled all the details. Now our products are fully protected on the platform.' },
];

export default function TestimonialSlider() {
  const plugin = useRef(Autoplay({ delay: 4000, stopOnInteraction: false }));

  return (
    <section className="py-20 lg:py-28 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-[#064E3B] mb-4">
            Real Stories From Real Brand Owners
          </h2>
          <p className="text-slate-600 text-base lg:text-lg max-w-2xl mx-auto">
            Trusted by thousands of businesses nationwide for trademark protection and corporate services.
          </p>
        </div>

        <div className="relative px-8 lg:px-14">
          <Carousel
            opts={{ align: 'start', loop: true }}
            plugins={[plugin.current]}
            className="w-full"
            data-testid="testimonial-carousel"
          >
            <CarouselContent className="-ml-4">
              {testimonials.map((t, i) => (
                <CarouselItem key={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <div className="testimonial-card h-full flex flex-col">
                    <div className="flex gap-1 mb-4">
                      {[...Array(5)].map((_, j) => (
                        <Star key={j} className="w-4 h-4 fill-amber-400 text-amber-400" />
                      ))}
                    </div>
                    <p className="text-sm text-slate-600 leading-relaxed flex-1 mb-4">"{t.text}"</p>
                    <div className="border-t pt-4">
                      <p className="font-heading font-semibold text-sm text-[#064E3B]">{t.name}</p>
                      <p className="text-xs text-slate-500">{t.role}</p>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="border-emerald-200 text-[#064E3B] hover:bg-emerald-50" />
            <CarouselNext className="border-emerald-200 text-[#064E3B] hover:bg-emerald-50" />
          </Carousel>
        </div>
      </div>
    </section>
  );
}
